/** Neutral border and divider colour, mirroring the Stencil design token. */
export const NEUTRAL_BORDER_COLOR = "var(--st-dt-color-neutral-20)";
